export const PRODUCT_AGGREGATES_REQUEST = 'dashboard/aggregates/actions/request';
export const PRODUCT_AGGREGATES_SUCCESS = 'dashboard/aggregates/actions/success';
export const PRODUCT_AGGREGATES_FAILURE = 'dashboard/aggregates/actions/failure';
